<template>
  <CreateSave
      :maxWidth="500"
      :setTitle="setTitle"
      :setItemForm="setItemForm"
      :createData="createData"
      @onCreate="(response) => $emit('onCreateTicketItem', response)"
      v-bind="$attrs"
  >
    <template
        v-slot:default="{
          errors,
          ItemForm
        }"
    >
      <v-row>
        <v-col
            cols="12"
        >
          <SuggestUsersRole
              v-model="ItemForm.User"
              :error-messages="errors.User"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Užívateľ"
              role="ROLE_WORKER"
              :createButton="$store.getters['auth/isLogged'] && $store.getters['auth/hasRole']('ROLE_MASTER')"
          />
        </v-col>

        <v-col
            cols="12"
        >
          <v-text-field
              v-model="ItemForm.timeEstimation"
              :error-messages="errors.timeEstimation"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Odhadovaný čas"
              type="number"
              suffix="h"
          />
        </v-col>

        <v-col
            cols="12"
        >
          <v-textarea
              v-model="ItemForm.note"
              :error-messages="errors.note"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Poznámka"
              :rows="5"
          />
        </v-col>
      </v-row>
    </template>
  </CreateSave>
</template>

<script>
  import TicketItemOffers from '@/services/ticket-item-offers'

  import CreateSave from '@/components/_Part/_Modal/_Save/Create'

  import SuggestUsersRole from '@/components/Users/SuggestRole'

  export default {
    name: 'CreateTicketItem',
    props: [
      'ticketItemId'
    ],
    emits: [
      'onCreateTicketItem'
    ],
    components: {
      CreateSave,
      SuggestUsersRole
    },
    methods: {
      setTitle() {
        return 'Vytvoriť ponuku'
      },
      setItemForm() {
        return {
          User: null,
          timeEstimation: 0,
          note: null
        }
      },
      createData(ItemForm) {
        return TicketItemOffers
          .createTicketItem({
            ticketItemId: this.ticketItemId,
            data: ItemForm
          })
      }
    }
  }
</script>
